import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { useStore } from '../store'

/**
 * Replaces window.confirm. The native dialog shows the host app's icon —
 * Electron's own in an unpackaged build — and is styled by the OS or browser
 * rather than the app, so it looks wrong on all three platforms.
 */
export function ConfirmDialog() {
  const req = useStore((s) => s.confirmState)
  const resolve = useStore((s) => s.resolveConfirm)
  const confirmRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!req) return
    confirmRef.current?.focus()
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); resolve(false) }
      if (e.key === 'Enter') { e.preventDefault(); resolve(true) }
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [req, resolve])

  if (!req) return null

  return createPortal(
    <div className="confirm-scrim" onMouseDown={() => resolve(false)}>
      <div className="confirm" role="alertdialog" aria-label={req.title}
           onMouseDown={(e) => e.stopPropagation()}>
        <div className="confirm-icon" aria-hidden>
          <img src="./favicon.png" alt="" width="52" height="52" />
        </div>
        <h2>{req.title}</h2>
        {req.message && <p>{req.message}</p>}
        <div className="confirm-actions">
          <button className="confirm-btn" onClick={() => resolve(false)}>Cancel</button>
          <button ref={confirmRef} className={`confirm-btn primary ${req.danger ? 'danger' : ''}`}
                  onClick={() => resolve(true)}>
            {req.confirmLabel ?? 'OK'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
